import React from 'react';
import dayjs from 'dayjs';
import { FORMAT_DATE_TIME_II } from 'constants/common.constant';
import CurrencyAmount from 'pages/Transactions/common/CurrencyAmount';
import StripeStatus from 'pages/Transactions/common/StripeStatus';

export const visibleColumnForSubsidyTransaction = [
  'transaction_time',
  'currency_symbol',
  'receipt_number',
  'amount',
  'transaction_status',
  'card_number',
  'pick_up_location',
  'drop_off_location',
  'receipt_url'
];

export const columnsConfig = [
  {
    accessor: 'transaction_time',
    Header: 'Date/Time',
    headerProps: { className: 'pe-3 text-900' },
    cellProps: {
      className: 'py-2 px-2'
    },
    Cell: rowData => {
      const { transaction_time } = rowData.row.original;
      return <>{transaction_time ? dayjs(transaction_time).format(FORMAT_DATE_TIME_II) : ''}</>;
    }
  },
  {
    accessor: 'currency',
    Header: 'Currency',
    width: 90,
    disableSortBy: true,
    headerProps: { className: 'text-start text-900' },
    cellProps: {
      className: 'text-start py-2 px-2 text-uppercase'
    }
  },
  {
    accessor: 'receipt_number',
    Header: 'Receipt #',
    width: 120,
    disableSortBy: true,
    headerProps: { className: 'pe-3 text-900' },
    cellProps: {
      className: 'py-2 px-2'
    }
  },
  {
    accessor: 'amount',
    Header: 'Subsidy Amount',
    width: 120,
    disableSortBy: true,
    headerProps: { className: 'text-end text-900' },
    cellProps: {
      className: 'justify-content-end'
    },
    Cell: rowData => {
      const { amount, currency_symbol } = rowData.row.original;
      return <CurrencyAmount amount={amount} symbol={currency_symbol} />;
    }
  },
  {
    accessor: 'transaction_status',
    Header: 'Status',
    width: 150,
    disableSortBy: true,
    headerProps: {
      className: 'text-center text-900'
    },
    cellProps: {
      className: 'fs-0 justify-content-center'
    },
    Cell: rowData => {
      const { transaction_status } = rowData.row.original;
      return <StripeStatus status={transaction_status} minWidth="135px" />;
    }
  },
  {
    accessor: 'pick_up_location',
    Header: 'Pick Up',
    width: 240,
    disableSortBy: true,
    headerProps: {
      className: 'text-start pe-2 text-900'
    },
    cellProps: {
      className: 'text-start py-2 px-2 text-capitalize'
    }
  },
  {
    accessor: 'drop_off_location',
    Header: 'Drop off',
    width: 240,
    disableSortBy: true,
    headerProps: {
      className: 'text-start pe-2 text-900'
    },
    cellProps: {
      className: 'text-start py-2 px-2 text-capitalize'
    }
  }
];
